import { ENDPOINTS } from "@common/constants/endpoints.ts";
import { setAriaProp } from "@common/utilities.js";

export default class RegistrationsForm {
	constructor(config) {
		this.el = config.el;
		this.formEl = this.el.querySelector("form");
		this.successOverlayEl = this.el.querySelector(
			".no-registrations__form-overlay"
		);
		this.inputFieldsList = this.el.querySelectorAll(".input-simple");

		this.labelActiveClass = "umbraco-forms-label--active"; // added to label when input receives focus or if input has value
		this.inputHasLabelClass = "input-simple--has-label"; // added to input when input receives focus or if input has value

		this.inputErrorValidationClass = "input-validation-error"; // added to <input> if it has errors
		this.errorValidationClass = "co-validmark--not-valid"; // added to .co-validmark if input has errors
		this.inputErrorTextClass = "field-validation-error"; // should be shown if input has errors

		this.inputValidValidationClass = "input-validation-valid"; // added to input if it's valid
		this.validValidationClass = "co-validmark--valid"; // added to .co-validmark if input is valid

		this.init();
	}

	init() {
		this.attachEvents();
	}
	attachEvents() {
		this.inputFieldsList.forEach((el) => {
			el.addEventListener(
				"focus",
				(e) => {
					this.setLabelActiveClass(e.target);
				},
				true
			);

			el.addEventListener(
				"blur",
				(e) => {
					this.removeLabelActiveClass(e.target);
				},
				true
			);

			el.addEventListener(
				"input",
				(e) => {
					setTimeout(() => {
						this.validateField(e.target);
					}, 500);
				},
				true
			);
		});

		this.formEl.addEventListener("submit", (e) => {
			e.preventDefault();
			if (this.formIsValid()) {
				this.submitForm();
			} else {
				this.inputFieldsList.forEach((el) => {
					this.validateField(el);
				});
			}
		});
	}

	formIsValid() {
		const invalidFields = Array.from(this.inputFieldsList)
			.map((el) => this.validateField(el, false))
			.filter((x) => x === false);
		return invalidFields.length === 0;
	}

	validateField(el, updateDOM = true) {
		const fieldWrapperEl = el.closest(".umbraco-forms-field");
		const { errorType, errorMandatory, errorInvalid } =
			fieldWrapperEl.dataset;
		const errorEl = fieldWrapperEl.querySelector(
			"." + this.inputErrorTextClass
		);
		let isValid = true;
		let errorLabel = "";

		// validate
		if (errorMandatory && !el.value) {
			// field is invalid
			errorLabel = errorMandatory;
			isValid = false;
		}
		if (errorInvalid) {
			let regex;
			switch (errorType) {
				case "phone":
					regex =
						/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/;
					break;
				case "email":
					regex =
						/^(?=^[\w.@!#$%&'*+/=?^`{|}~-]{7,254}$)(?<username>(?=^[\w.!#$%&'*+/=?^`{|}~-]{1,64}@)[\w!#$%&'*+/=?^`{|}~-]+(?:\.[\w!#$%&'*+/=?^`{|}~-]+)*)@(?<domain>(?=\b[a-z\d.-]{5,252}$)(?:[a-z\d](?:[a-z\d-]{0,61}[a-z\d])\.)+(?:(?:[a-z](?:[a-z-]{0,61}[a-z]))|(?:(?=[a-z\d-]*?[a-z])(?=[a-z\d-]*?[\d])[a-z\d](?:[a-z\d-]{0,61}[a-z\d]))))$/i;
					break;
				default:
					break;
			}

			const matchesRegex = el.value.match(regex);
			if (!matchesRegex) {
				errorLabel = errorInvalid;
				isValid = false;
			}
		}
		if (!errorMandatory && !el.value) {
			//optional field is valid if it's empty
			isValid = true;
		}

		if (updateDOM) {
			setAriaProp(el, "invalid", !isValid);

			if (isValid) {
				el.classList.remove(this.inputErrorValidationClass);
				el.classList.add(this.inputValidValidationClass);
				el.closest(".co-validmark").classList.remove(
					this.errorValidationClass
				);
				el.closest(".co-validmark").classList.add(
					this.validValidationClass
				);
				errorEl.classList.add("hidden");
				errorEl.textContent = "";
			} else {
				el.classList.add(this.inputErrorValidationClass);
				el.classList.remove(this.inputValidValidationClass);
				el.closest(".co-validmark").classList.add(
					this.errorValidationClass
				);
				el.closest(".co-validmark").classList.remove(
					this.validValidationClass
				);
				errorEl.classList.remove("hidden");
				errorEl.textContent = errorLabel;
			}
		}

		return isValid;
	}

	submitForm() {
		const formData = {
			ModuleName: document.title,
			ModuleLink: window.location.origin + window.location.pathname,
			RegistrationName: this.el.querySelector("#registration-name").value,
			RegistrationPhone: this.el.querySelector("#registration-phone")
				.value,
			RegistrationEmail: this.el.querySelector("#registration-email")
				.value,
		};

		this.inputFieldsList.forEach((el) => {
			el.setAttribute("disabled", "disabled");
		});
		this.el.querySelector("button").setAttribute("disabled", "disabled");

		fetch(ENDPOINTS.subscribeToModule, {
			method: "POST",
			headers: {
				Accept: "application/json, text/plain, */*",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formData),
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				this.successOverlayEl.classList.add("show");
				this.el.querySelector("button").style.opacity = "0";
				this.successOverlayEl.focus();
			})
			.catch((err) => {
				console.log(err);
			});
	}

	setLabelActiveClass(el) {
		const formEle = el.closest(".umbraco-forms-field");
		const labelEle = formEle.querySelector(".umbraco-forms-label");

		if (labelEle != null) {
			labelEle.classList.add(this.labelActiveClass);
			el.classList.add(this.inputHasLabelClass);
		}
	}

	removeLabelActiveClass(el) {
		const formEle = el.closest(".umbraco-forms-field");
		const labelEle = formEle.querySelector(".umbraco-forms-label");

		if (labelEle != null && el.value == "") {
			labelEle.classList.remove(this.labelActiveClass);
			el.classList.remove(this.inputHasLabelClass);
		}
	}
}
